import { Stack, Typography } from '@mui/material'
import React from 'react'
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';

function NavBarProfile() {
    return (
        <>

            <Stack sx={{ alignItems: "end", my: 1 }}>
                <Typography sx={{ display: "flex", alignItems: "center" }}>
                </Typography>
            </Stack >
        </>
    )
}

export default NavBarProfile